export default __webpack_public_path__ + "static/services-software-c1b49f51b20d8be8657340dc22d85c47.svg";